import { useRouter } from 'next/router';

export const useIdQueryHandler = (key = 'id'): number | null => {
  const id = useRouter().query[key] ?? null;
  return id === null ? null : Number(id);
};
